module.exports = __webpack_public_path__ + "static/media/bird-goose2.f8389be1.aac";